import React from "react";
import DropDownIcon from "../../assets/icons/dropdown-icon.svg";
import "./selectComponent.css";

const SelectComponent = ({
  label,
  options,
  onChange,
  value,
  name,
  placeholder,
  onBlur,
}) => {
  return (
    <div className="select-group">
      {label && <label className="select-label">{label}</label>}
      <div className="select-container">
        <select
          className={`form-select-style ${
            value === "" ? "default-selected" : "option-selected"
          }`}
          value={value}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="dropdown-icon">
          <img src={DropDownIcon} alt="" />
        </span>
        {/* Dropdown arrow */}
      </div>
    </div>
  );
};

export default SelectComponent;
